import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

export default defineNuxtPlugin(() => {
    const runtimeConfig = useRuntimeConfig();
    const authStore = useAuthStore();
    const wsKey = runtimeConfig.public.pusherAppKey;
    const wsHost = runtimeConfig.public.pusherHost;
    const wsPort = parseInt(runtimeConfig.public.pusherPort);
    const forceTLS = String(runtimeConfig.public.pusherForceTls) === 'true';

    const websocket = new Echo({
        broadcaster: 'pusher',
        Pusher,
        // Read at authorization time: login and impersonation change the token without reloading the app.
        channelAuthorization: {
            transport: 'ajax',
            endpoint: `${runtimeConfig.public.worksiteApiUrl}/broadcasting/auth`,
            headersProvider: () => ({ Authorization: authStore.usableToken ?? '' }),
        },
        key: wsKey,
        cluster: 'mt1',
        wsHost,
        wsPort,
        wssPort: wsPort,
        forceTLS,
        encrypted: forceTLS,
        disableStats: true,
        enabledTransports: forceTLS ? ['ws', 'wss'] : ['ws'],
    });

    return {
        provide: {
            websocket,
        },
    };
});
